/* eslint-disable vue/return-in-computed-property */
<template>
<div>
    <vue-headful :title="titlePage" />
    <md-card-header class="md-card-header-icon md-card-header-site">
        <div class="md-layout">
            <div class="card-icon">
                <h4 class="title page-title">{{ titlePage || "TITULO DA PAGINA" }}</h4>
            </div>
            <div v-if="!btnHide" class="md-layout-item md-size-10 md-small-size-50 btn-title">
                <drop-down direction="down">
                    <md-button slot="title" class="md-button md-site md-round md-block dropdown-toggle" data-toggle="dropdown">
                        Opções
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                       <li @click="reportPDF('imprimir')">
                            <a><i class="fas fa-print text-primary"></i> Imprimir</a>
                        </li>
                        <li @click="reportPDF('salvar')">
                            <a><i class="fas fa-file-pdf text-danger"></i> PDF</a>
                        </li>
                        <li class="btn-excel">
                            <a>
                                <vue-excel-xlsx :data="dadosRel || data" :columns="columnsExcel" :filename="titleReport" sheetname="Planilha1">
                                    <i class="fas fa-file-excel text-success"></i> Excel
                                </vue-excel-xlsx>
                            </a>
                        </li>
                        <li @click="reportTXT">
                            <a><i class="fas fa-file-alt text-info"></i> TXT</a>
                        </li>
                    </ul>
                </drop-down>
            </div>
            <div>
            </div>
            <div class="md-layout-item md-size-10 md-small-size-50 btn-title">
                <slot />              
            </div>
        </div>
    </md-card-header>
</div>
</template>

<script>
import docExport from "@/config/mixins/docExport";

export default {
    name: 'HeaderTable',
    props: [
        'titlePage', 'data', 'dadosRel', 'columnsPDF', 'headRowsPDF', 'titleReport', 'fildsTXT', 'columnsExcel', 'bodyRowsPDF',
        'colSpanPDF', 'totalPDF', 'btnHide', 'totalHide', 'forma'
    ],
    
    mixins: [docExport],
        
    methods: {       
        reportTXT() {
            let campos = this.fildsTXT;
            this.loader = this.docTXT(this.dadosRel || this.data, campos, this.titleReport)
        },

        reportPDF(tipoSaida) {
            let tipo = tipoSaida;
            // Dife o tamanho da coluna
            let columns = this.columnsPDF;
            // Cria o header da table
            let headRows = this.headRowsPDF;
            // Cria o array de valores para a table
            let bodyRows = [];
            let result = []

            this.data.forEach(item => {
                result = this.bodyRowsPDF.map(function (e) {
                    if (item[e] == null || item[e] == '') {
                        return item[e]
                    } else {                        
                        return item[e].toString().toUpperCase()
                    }
                })
                bodyRows.push(result)
            });

            var rowTotal = [{
                colSpan: this.colSpanPDF,
                descricao: 'QTDE: ' + this.numMilhar(this.totalPDF)
            }]

            if (!this.totalHide) {                
                bodyRows.push(this.totalTable(rowTotal))
            }

            // chama a função e passa as variáveis
            this.relPDF(bodyRows, headRows, columns, this.titleReport, tipo, this.titleReport, null, null, this.forma);
        },
    },
}
</script>

<style>
.btn-excel button {
    background-color: transparent !important;
    border: none !important;
    padding-left: 0 !important;
}

.btn-excel :hover {
    color: #fff !important;
}
</style>
